// extracted by mini-css-extract-plugin
export var nav = "nav-module--nav--6LHsO";
export var actions = "nav-module--actions---b5l9";
export var social = "nav-module--social--y-kwm";
export var main = "nav-module--main--fECAo";